import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { Box, Typography } from '@mui/material';

const containerStyle = {
  width: '90%',
  height: '400px',
  margin: '0 auto',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
};

const center = {
  lat: 48.8566,
  lng: 2.3522
};

const MapSection: React.FC = () => {
  return (
    <Box sx={{ 
      width: '100%', 
      height: '500px',
      position: 'relative',
      backgroundColor: '#C9B6AB',
      padding: '2rem 0'
    }}>
      <Typography 
        variant="h4" 
        sx={{ 
          textAlign: 'center',
          color: 'white',
          marginBottom: '2rem',
          fontFamily: 'Playfair Display',
          fontStyle: 'italic'
        }}
      >
        Découvrez les robes proches de chez vous
      </Typography>
      
      <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={12}
          options={{
            styles: [
              {
                featureType: "poi",
                elementType: "labels",
                stylers: [{ visibility: "off" }]
              }
            ]
          }}
        >
          {/* Les marqueurs des robes seront ajoutés ici plus tard */}
        </GoogleMap>
      </LoadScript>
    </Box>
  );
};

export default MapSection; 